/**
 * CampsiteOrderItem.jsx
 * Created by Stephanie Condrey on 11/14/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../icons/Icons';

const propTypes = {
    orderItemTitle: PropTypes.string,
    orderItemDetailOne: PropTypes.string,
    orderItemDetailTwo: PropTypes.string,
    orderItemPrice: PropTypes.string,
    showModal: PropTypes.func,
    adjustmentFeeChange: PropTypes.bool
};

export default class CampsiteOrderItem extends React.Component {
    render() {
      let modifyPrice = null;
      if (this.props.adjustmentFeeChange) {
        modifyPrice = (
          <button
            className="modify-price"
            onClick={() => this.props.showModal()}>
            <Icons.IconEdit /> Adjust Fees
          </button>);
      }
        return (
            <div className="rec-order-item-row">
                <div className="rec-order-item-col">
                    <div className="h4">{this.props.orderItemTitle}</div>
                    <p>{this.props.orderItemDetailOne}</p>
                    <p>{this.props.orderItemDetailTwo}</p>
                </div>
                <div className="rec-order-item-col">
                    {modifyPrice}
                    <p className="item-price">{this.props.orderItemPrice}</p>
                    <p className="item-actions"><a href="#/">Edit</a> &#124; <a href="#/">Remove</a></p>
                </div>
            </div>
        );
    }
}
CampsiteOrderItem.propTypes = propTypes;
